export function ErrorBanner({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div className="alert-error" role="alert">
      {message}
    </div>
  );
}
